import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from 'react-router-dom';

import ShippingMethods from "./ShippingMethods";
import {
    enableCouponApplication,
    removeExplicitCoupon,
    setCouponEmail,
    suppressAutomaticCoupon
} from '../../../helpers/shop/couponSession';

import { msg, basicMsg, valMsg, basicTimerMsg } from "../../../actions/swal_msg";

import { getCartItems } from "../../../actions/shop";

import {
    TextField, List, ListItem, ListItemText, Typography,
    Button, Grid, Box, Divider, Collapse, Chip, Link, Alert,
    Stack, Dialog, DialogActions, DialogContent, DialogTitle
} from "@mui/material";
import LoadingButton from '@mui/lab/LoadingButton';

import SaveIcon from '@mui/icons-material/Save';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';

import { FREE_SHIPPING_THRESHOLD } from "../../../constants/shop/shop_constants";
import { is_visible, no_visible } from "../../../constants/constants";

const CartSummary = () => {
    const dispatch = useDispatch();
    const [emailDialog, setEmailDialog] = useState(false);
    const [couponEmail, setCouponEmailInput] = useState('');
    const navigate = useNavigate();

    const {
        cart: {
            item, // productos de carrito
            summary: {
                promos_discount, discount,
                subtotal, total
            },
            item_summary, // Tu orden
            cart_promotion, // promociones disponibles
            coupon, // cupón aplicado
            requires_cart_review,
        },
        shipping: {
            methods: { selected }
        }
    } = useSelector(state => state.shop);

    // bandera [carga de productos]
    const { loading: { shopping_cart } } = useSelector(state => state.ui);

    // usuario iniciado
    const { loggedUser } = useSelector(state => state.user);
    const { email } = loggedUser;

    // campo de cupón
    const pendingCoupon = useSelector(state => state.shop.login_cart_review?.pending_coupon || '');
    const [couponInput, setCouponInput] = useState(pendingCoupon);
    const [btlConfirmation, setBtlConfirmation] = useState({
        open: false,
        code: '',
        data: null
    });

    const handleCouponChange = ({ target }) => {
        setCouponInput(target.value.toUpperCase());
    };

    // aplicar cupón de descuento
    const applyCoupon = async (acceptBtl = false) => {
        const code = (btlConfirmation.code || couponInput).trim().toUpperCase();
        if (code.length < 3) {
            msg('warning', 'Cupón o código médico', 'Escribe un código válido');
            return;
        }
        enableCouponApplication();
        const result = await dispatch(getCartItems(false, {
            coupon_name: code,
            accept_btl: acceptBtl
        }));
        if (result?.resp?.coupon_email_required) { setEmailDialog(true); return; }
        if (result?.resp?.coupon?.locked_email) setEmailDialog(false);
        const confirmation = result?.resp?.btl_confirmation;
        if (confirmation) {
            setBtlConfirmation({ open: true, code, data: confirmation });
            return;
        }
        setBtlConfirmation({ open: false, code: '', data: null });
        if (result?.status && !result.resp?.coupon?.name && !result.resp?.cart_msg?.length)
            msg('warning', 'Cupón o código médico', 'No se ha encontrado un código disponible');
    };

    // dirigirse a checkout
        const goToCheckout = () => {
        if (shopping_cart)
            basicTimerMsg('Cargando su carrito...');
        // se ha seleccionado método de pago
        else if (selected._id !== '')
            nextPage();
        else
            basicMsg('Seleccione método de envío');
    };

    // navegación
    const nextPage = () => {
        if (requires_cart_review) {
            basicMsg('Confirma o descarta el código pendiente antes de continuar.');
            return;
        }
        // productos sin cantidad válida
        const validation = item.find(e => (['', '0', 0].includes(e.quantity)));
        if (validation)
            valMsg('info', 'Carrito',
            'Ingrese cantidad a los productos o elimínelos');
        else {
            if (email !== '')
                navigate('/checkout');
            else navigate('/login-l');
        }
    };

    //Collapse para cupón
    const [open, setOpen] = useState(Boolean(pendingCoupon));
    const handleClick = () => {
        setOpen(!open);
    };

    // eliminar cupón aplicado
    const removeOnClick = () => {
        if (coupon?.use_method === 'auto') suppressAutomaticCoupon();
        else removeExplicitCoupon();
        setCouponInput('');
        setBtlConfirmation({ open: false, code: '', data: null });
        dispatch(getCartItems(false, { coupon_name: '' }));
    };
    
    const amountForFreeShipping = FREE_SHIPPING_THRESHOLD + 0.01;
    const restante = Math.max(0, Math.round((amountForFreeShipping - subtotal) * 100) / 100);

    return (
        <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
            <Dialog open={emailDialog} onClose={() => setEmailDialog(false)} fullWidth maxWidth="xs">
                <DialogTitle>Correo para utilizar el cupón</DialogTitle>
                <DialogContent>
                    <Typography variant="body2" sx={{ mb: 2 }}>Introduce el correo con el que realizarás la compra. Si el cupón es válido, ese correo quedará fijo en tu dirección de envío.</Typography>
                    <TextField autoFocus fullWidth type="email" label="Correo electrónico" value={couponEmail}
                        onChange={event => setCouponEmailInput(event.target.value)} />
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setEmailDialog(false)}>Cancelar</Button>
                    <Button disabled={!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(couponEmail.trim())}
                        onClick={() => { setCouponEmail(couponEmail); applyCoupon(); }}>Validar cupón</Button>
                </DialogActions>
            </Dialog>
            <Box sx={{ p: 3 }} className="total-cart-box-shadow"
                style={ item_summary.length > 0 ? is_visible : no_visible }>
                <Typography variant='h5' sx={{ fontWeight: '600', textAlign: { xs: 'center', sm: 'center', md: 'left' } }}>
                    Tu orden
                </Typography>
                <List disablePadding>
                    {
                        item_summary.map((e, i) => {
                            return (
                                <ListItem sx={{ px: 0, pr: 1 }} key={i}>
                                    <ListItemText
                                        primary={
                                            `${e.title} ${e.variant_title} (${e.quantity})`
                                        }
                                        secondary={
                                            <Typography
                                                sx={{ display: 'inline' }}
                                                component="span"
                                                variant="body2">
                                                { `${ e.promo_text } ` }
                                            </Typography>
                                        } />
                                    {
                                        (
                                            e.discount_by_promo !== 0 ||
                                            e.discount_by_coupon !== 0
                                        ) ?
                                            <Stack spacing={1}>
                                                <Typography sx={{ color: '#000', fontWeight: '600', textDecoration: 'line-through' }}
                                                    variant="body2">
                                                    ${ e.item_subtotal }
                                                </Typography>
                                                <Typography sx={{ color: '#229954', fontWeight: '600' }} variant="body2">
                                                    ${ e.item_total }
                                                </Typography>
                                            </Stack>
                                        :
                                            <Typography sx={{ color: '#229954', fontWeight: '600' }} variant="body2">
                                                ${ e.item_subtotal }
                                            </Typography>
                                    }
                                </ListItem>
                            )
                        })
                    }

                    <Divider sx={{ my: 2 }} />

                    {
                        (coupon && coupon.name) && (
                            <ListItem sx={{ px: 0 }}>
                                <ListItemText
                                    primary={ coupon.name }
                                    secondary={
                                        coupon._class === 'order_discount' ?
                                            `Cupón ${
                                                coupon.discount.type === 'fixed' ?
                                                    `$${coupon.discount._value}`
                                                :
                                                    `${coupon.discount._value}%`
                                            }`
                                        :
                                            `Cupón Envío Gratis`
                                    }
                                />
                                <Typography sx={{ color: '#C0392B', fontWeight: '600' }}
                                    variant="body2">
                                    {
                                        coupon._class === 'order_discount' ?
                                            `- $${
discount
                                            }`
                                        :
                                            `¡Tiene envío gratis!`
                                    }
                                </Typography>
                            </ListItem>
                        )
                    }

                    {
                        promos_discount !== 0 &&
                            <ListItem sx={{ px: 0 }}>
                                <ListItemText primary="Descuento por promociones" secondary={
                                    `${ cart_promotion.filter(e => e.active).length } activa(s)`
                                } />
                                <Typography sx={{ color: '#C0392B', fontWeight: '600' }}
                                    variant="body2">
                                    - ${ promos_discount }
                                </Typography>
                            </ListItem>
                    }

                    {
                        (selected && selected._id) &&
                            <ListItem sx={{ px: 0 }}>
                                <ListItemText primary="Envío" />
                                <Typography sx={{ color: '#229954', fontWeight: '600' }}
                                    variant="body2">
                                    { selected.cost === 0 ? 'Gratis': `$${selected.cost}` }
                                </Typography>
                            </ListItem>
                    }
                    {
                        (
                            (subtotal <= FREE_SHIPPING_THRESHOLD) &&
                            (!coupon || coupon._class !== 'free_shipping') &&
                            (!coupon?.name || coupon._class !== 'order_discount')
                        ) &&
                            <Alert severity="info" sx={{ my: 1 }}>
                                {
                                    `Agrega $${ restante.toFixed(2) } más al carrito de compras y el envío será ¡GRATIS!`
                                }
                            </Alert>
                    }
                    
                    {
                        selected._id &&
                            <Typography sx={{ fontStyle: 'italic', fontWeight: '600', mb: 1 }}
                                variant="body2">
                                Los tiempos estimados de entrega pueden variar acorde a la paquetería
                            </Typography>
                    }

                    <ShippingMethods
                        display={
                            (
                                subtotal <= FREE_SHIPPING_THRESHOLD ||
                                Boolean(coupon?.name && coupon._class === 'order_discount')
                            ) &&
                            (!coupon || coupon._class !== 'free_shipping')
                            ? true : false
                        }
                        fill={ false }
                    />

                    <ListItem sx={{ px: 0 }}>
                        <ListItemText primary="Subtotal" />
                        <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
                            ${ subtotal }
                        </Typography>
                    </ListItem>

                    <Divider sx={{ my: 2 }} />

                    {
                        selected._id &&
                            <ListItem sx={{ px: 0 }}>
                                <ListItemText primary="Total + envío" />
                                <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
                                    ${ total }
                                </Typography>
                            </ListItem>
                    }
                </List>

                {
                    shopping_cart ?
                        <LoadingButton
                            sx={{ width: '100%', height: '50px' }}
                            loading
                            loadingPosition="start"
                            startIcon={<SaveIcon />}
                            variant="outlined">
                            Continuar
                        </LoadingButton>
                    :
                        <Button variant='contained' sx={{ width: '100%', height: '50px' }}
                            onClick={ goToCheckout }>
                            Continuar
                        </Button>
                }

                {/* Sección para aplicar cupón */}
                <Box sx={{ mt: 2 }}>
                    {requires_cart_review && <Alert severity="info" sx={{ mb: 2 }}
                        action={<Button color="inherit" size="small" onClick={removeOnClick}>Descartar</Button>}>
                        Confirma el código o el correo de compra antes de continuar. También puedes descartar el código.
                    </Alert>}
                    <Link onClick={handleClick} style={{
                        display: 'flex', justifyContent: 'space-between',
                        cursor: 'pointer', textDecoration: 'none'
                    }}>
                        Aplicar cupón o código médico
                        <span>{ open ? <ExpandLess /> : <ExpandMore /> }</span>
                    </Link>
                    <Collapse in={open} timeout="auto" unmountOnExit>
                        <Box sx={{ display: 'flex', mt: 2 }}>
                            <TextField label="Código" variant="outlined"
                                onChange={ handleCouponChange }
                                value={ couponInput }
                                size='small' fullWidth sx={{ mr: 1.5 }} />
                            <Button variant='contained' size='small'
                                sx={{ textTransform: 'none' }} onClick={() => applyCoupon(false)}>
                                Aplicar
                            </Button>
                        </Box>
                    </Collapse>
                    <Box>
                        {
                            coupon.name !== '' && (
                                <>
                                    <Box sx={{
                                        display: 'flex',
                                        justifyContent: 'flex-start',
                                        mt: 2
                                    }}>
                                    <Typography variant='body1'
                                        sx={{ my: 'auto', fontWeight: '600' }}>
                                            {coupon.source === 'btl' ? 'Código médico BTL:' : 'Cupón aplicado:'}
                                        </Typography>
                                        {
                                            <Chip
                                                label={ coupon.name }
                                                onDelete={ removeOnClick }
                                                sx={{ my: 'auto', ml: 1 }}
                                                color='primary'
                                                size="small"
                                            />
                                        }
                                        
                                    </Box>
                                    <Typography variant='overline' sx={{ fontStyle: 'italic' }}>
                                        { coupon.description }
                                    </Typography>
                                </>
                            )
                        }
                    </Box>
                </Box>
                {/* Fin seccion para aplicar cupón */}
            </Box>
            <Dialog
                open={btlConfirmation.open}
                onClose={() => setBtlConfirmation({ open: false, code: '', data: null })}
                fullWidth
                maxWidth="sm"
            >
                <DialogTitle>Comparar beneficios</DialogTitle>
                <DialogContent dividers>
                    <Alert severity="warning" sx={{ mb: 2 }}>
                        Aplicar el código médico sustituirá las promociones actuales y el envío gratis por mínimo de compra.
                    </Alert>
                    {btlConfirmation.data && (
                        <Stack spacing={2}>
                            <Box>
                                <Typography fontWeight={600}>Beneficios actuales</Typography>
                                <Typography variant="body2">
                                    Promociones: -${btlConfirmation.data.current.promotions_savings}
                                </Typography>
                                <Typography variant="body2">
                                    Envío: ${btlConfirmation.data.current.shipping}
                                </Typography>
                                <Typography variant="body2" fontWeight={600}>
                                    Total: ${btlConfirmation.data.current.total}
                                </Typography>
                            </Box>
                            <Divider />
                            <Box>
                                <Typography fontWeight={600}>Con código médico</Typography>
                                <Typography variant="body2">
                                    Descuento médico: -${btlConfirmation.data.btl.coupon_savings}
                                </Typography>
                                <Typography variant="body2">
                                    Envío regular: ${btlConfirmation.data.btl.shipping}
                                </Typography>
                                <Typography variant="body2" fontWeight={600}>
                                    Total: ${btlConfirmation.data.btl.total}
                                </Typography>
                            </Box>
                            {btlConfirmation.data.products_losing_promotion.length > 0 && (
                                <Box>
                                    <Typography variant="body2" fontWeight={600}>Productos que pierden promoción</Typography>
                                    {btlConfirmation.data.products_losing_promotion.map((product, index) => (
                                        <Typography key={index} variant="caption" display="block">
                                            {product.title}: -${product.discount}
                                        </Typography>
                                    ))}
                                </Box>
                            )}
                            <Box>
                                <Typography variant="body2" fontWeight={600}>Descuento médico por producto</Typography>
                                {btlConfirmation.data.medical_products.map((product, index) => (
                                    <Typography key={index} variant="caption" display="block">
                                        {product.title}: -${product.discount}
                                    </Typography>
                                ))}
                            </Box>
                        </Stack>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setBtlConfirmation({ open: false, code: '', data: null })}>
                        Conservar beneficios
                    </Button>
                    <Button variant="contained" onClick={() => applyCoupon(true)}>
                        Aplicar código
                    </Button>
                </DialogActions>
            </Dialog>
        </Grid>
    );
};

export default CartSummary;
